import { render, staticRenderFns } from "./BaseInputCNPJ.vue?vue&type=template&id=037b0bbb&"
import script from "./BaseInputCNPJ.vue?vue&type=script&lang=js&"
export * from "./BaseInputCNPJ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports